import * as React from "react";
import ConnectedReplyRabbit from "../containers/ReplyRabbitContainer";

class DialogIText extends React.Component {
  constructor(props: {}) {
    super(props);
  }

  public render() {
    return (
      <div className="dialogI-text dialogGHI-text">
        <ConnectedReplyRabbit />
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          viewBox="0 0 344.176 294.544"
        >
          <g>
            <path
              fill="#F17752"
              d="M66.7,84.7c0.6,0.7,2.2,2.5,2.5,2.9L68,89.7c-0.3-0.6-0.8-1.5-1.4-2.3v8.2h-2.1V89c-0.5,1.4-1.2,2.6-1.8,3.5
		c-0.2-0.6-0.7-1.4-1.1-2c1.2-1.6,2.2-4.1,2.8-6.3h-2.3v-2h2.4v-3.3h2.1v3.3h2.1v2h-2.1V84.7z M78.5,84.7h-2.2v8.2
		c0,1.3-0.3,1.9-1.1,2.3c-0.8,0.4-2,0.4-3.8,0.4c-0.1-0.6-0.5-1.7-0.8-2.3c1.3,0.1,2.6,0.1,3,0.1c0.4,0,0.5-0.1,0.5-0.5v-8.2h-4.9
		v-2.1h4.9v-3.7h2.2v3.7h2.2V84.7z M71.3,90.9c-0.3-1.2-1.1-3-1.8-4.3l1.8-0.7c0.8,1.3,1.6,3,1.9,4.2L71.3,90.9z"
            />
            <path
              fill="#F17752"
              d="M95.8,90.3c-1,0.7-2.1,1.4-3.2,2c1.1,0.7,2.5,1.2,4.1,1.5c-0.5,0.4-1.1,1.3-1.4,1.9c-4-0.9-6.4-3-8-6.3h-2.6
		v3.8l3.9-0.8c-0.1,0.6-0.2,1.5-0.2,1.9c-4.3,1-5.3,1.2-5.8,1.4l-0.1,0.1c-0.1-0.5-0.6-1.6-0.9-2.1c0.4-0.2,0.9-0.6,0.9-1.4v-2.9
		h-2.6v-1.9h3v-8h11.4v1.7h-9.2v1h8.7v1.7h-8.7v0.9h8.7v1.7h-8.7v1h11.1v1.9h-1.9L95.8,90.3z M89.6,89.3c0.4,0.7,0.9,1.3,1.5,1.8
		c0.9-0.6,1.9-1.2,2.6-1.8H89.6z"
            />
            <path
              fill="#F17752"
              d="M112.8,91.9c0.5,0.3,1.3,0.6,1.8,0.7c-0.2,2.4-0.8,3-2.6,3h-2.8c-2.3,0-2.8-0.6-2.8-2.6v-2.9
		c-1,2.4-3.1,4.4-7.4,5.5c-0.2-0.6-0.7-1.4-1.2-1.8c3.6-0.9,5.4-2.3,6.4-4.1h-4.5v-4.2c-0.2,0.2-0.4,0.3-0.6,0.5
		c-0.3-0.5-1-1.3-1.5-1.6c2.5-1.6,4.2-3.8,5.1-5.7l2.3,0.4c-0.1,0.3-0.3,0.6-0.5,0.8h3.6l0.3-0.1l1.5,1c-0.5,0.8-1.1,1.7-1.7,2.5h5
		v6.4h-2.4C111.5,90.5,112.4,91.3,112.8,91.9L112.8,91.9z M104.8,87.9c0.2-0.8,0.3-1.7,0.4-2.6h-3.4v2.6H104.8z M103.3,81.8
		c-0.4,0.6-0.8,1.1-1.3,1.6h3.7c0.4-0.5,0.8-1,1.2-1.6H103.3z M110.9,85.3h-3.5c-0.1,0.9-0.2,1.8-0.4,2.6h3.9V85.3z M111.8,93.7
		c0.6,0,0.8-0.3,0.9-1.7l-1.3,1.2c-0.5-0.6-1.5-1.7-2.3-2.4l1.2-1h-1.7V93c0,0.6,0.1,0.7,0.9,0.7H111.8z"
            />
            <path
              fill="#F17752"
              d="M130.8,91.9c0.5,0.3,1.3,0.6,1.8,0.7c-0.2,2.4-0.8,3-2.6,3h-2.8c-2.3,0-2.8-0.6-2.8-2.6v-2.9
		c-1,2.4-3.1,4.4-7.4,5.5c-0.2-0.6-0.7-1.4-1.2-1.8c3.6-0.9,5.4-2.3,6.4-4.1h-4.5v-4.2c-0.2,0.2-0.4,0.3-0.6,0.5
		c-0.3-0.5-1-1.3-1.5-1.6c2.5-1.6,4.2-3.8,5.1-5.7l2.3,0.4c-0.1,0.3-0.3,0.6-0.5,0.8h3.6l0.3-0.1l1.5,1c-0.5,0.8-1.1,1.7-1.7,2.5h5
		v6.4h-2.4C129.5,90.5,130.4,91.3,130.8,91.9L130.8,91.9z M122.8,87.9c0.2-0.8,0.3-1.7,0.4-2.6h-3.4v2.6H122.8z M121.3,81.8
		c-0.4,0.6-0.8,1.1-1.3,1.6h3.7c0.4-0.5,0.8-1,1.2-1.6H121.3z M128.9,85.3h-3.5c-0.1,0.9-0.2,1.8-0.4,2.6h3.9V85.3z M129.8,93.7
		c0.6,0,0.8-0.3,0.9-1.7l-1.3,1.2c-0.5-0.6-1.5-1.7-2.3-2.4l1.2-1h-1.7V93c0,0.6,0.1,0.7,0.9,0.7H129.8z"
            />
            <path
              fill="#F17752"
              d="M148.5,93.5c0.3,0,0.4-0.2,0.4-1.9c0.4,0.3,1.3,0.7,1.8,0.8c-0.2,2.4-0.7,3.1-2,3.1h-1.2c-1.6,0-2-0.6-2-2.5
		v-3.6h-0.8c-0.3,2.8-0.9,5.1-3.9,6.4c-0.2-0.4-0.7-1.1-1.1-1.5v0.4h-3.5v0.8h-1.8v-6.2h5.3v4.8c2.2-1,2.6-2.6,2.8-4.7h-1.2v-4.9
		c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3-0.4-1.1-1.2-1.5-1.5l0.1-0.1h-5.6v-1.7h2.7c-0.2-0.7-0.5-1.6-0.9-2.3l1.8-0.6
		c0.4,0.7,0.8,1.7,1,2.3l-1.4,0.5h3.2v1c1-1,2-2.4,2.6-3.7l2,0.6c-0.6,1.4-1.5,2.8-2.5,4h6.2c-0.8-1.2-1.9-2.6-3-3.7l1.5-1
		c1.4,1.4,3.1,3.4,3.8,4.8l-1.6,1.2c-0.1-0.2-0.2-0.4-0.4-0.6v5.1h-1.1V93c0,0.5,0,0.6,0.3,0.6H148.5z M139.6,86h-5.1v-1.6h5.1V86z
		 M134.5,86.8h5.1v1.6h-5.1V86.8z M138.1,90.9h-1.7v2h1.7V90.9z M143.5,87.5h3.2v-2h-3.2V87.5z"
            />
            <path
              fill="#F17752"
              d="M154,83.1c0-1,0.8-1.7,1.7-1.7s1.7,0.7,1.7,1.7c0,1-0.8,1.7-1.7,1.7S154,84.1,154,83.1z M154,91.7
		c0-1,0.8-1.7,1.7-1.7s1.7,0.7,1.7,1.7c0,1-0.8,1.7-1.7,1.7S154,92.7,154,91.7z"
            />
            <path fill="#F17752" d="M64,102.4h6v1.9h-3.8v9.6H64V102.4z" />
            <path
              fill="#F17752"
              d="M76.5,103.2c-0.5,1.2-1,2.5-1.7,3.7v12.4h-2.1V110c-0.4,0.5-0.8,1-1.2,1.5c-0.2-0.5-0.8-1.7-1.2-2.2
		c1.6-1.6,3.2-4.2,4.1-6.7L76.5,103.2z M82.9,107.7v9.2c0,1-0.2,1.6-0.8,2c-0.6,0.3-1.5,0.4-2.6,0.4c-0.1-0.6-0.4-1.6-0.7-2.2
		c0.8,0,1.5,0,1.8,0c0.2,0,0.3-0.1,0.3-0.3v-9.2h-2.1c-0.5,1-1.1,2-1.7,2.8c-0.4-0.4-1.2-1.1-1.7-1.4c1.4-1.5,2.4-4,3.1-6.5l2.1,0.5
		c-0.2,0.9-0.5,1.8-0.8,2.7h6.2l0.3-0.1l1.5,0.3c-0.2,1.5-0.5,3.1-0.8,4.2l-1.8-0.3c0.1-0.6,0.2-1.3,0.3-2.1H82.9z M79.9,110.9
		c-0.5,2.3-1.4,4.6-2.4,6c-0.4-0.3-1.3-0.9-1.8-1.2c1-1.3,1.8-3.3,2.2-5.3L79.9,110.9z M85.5,110.3c0.9,1.9,1.7,4.2,2,5.9l-2.1,0.7
		c-0.2-1.6-1-4.1-1.8-5.9L85.5,110.3z"
            />
            <path
              fill="#F17752"
              d="M92,113c-0.4,1.8-1.1,3.6-1.8,4.8c-0.3-0.3-1.1-0.8-1.5-1c0.7-1,1.2-2.6,1.5-4.2L92,113z M97.3,106.4h-8.2
		v-1.9h3.4c-0.2-0.5-0.4-1.2-0.6-1.7l2-0.4c0.3,0.6,0.6,1.4,0.8,2.1h2.7V106.4z M94.4,112.1v5.1c0,0.9-0.1,1.3-0.7,1.6
		c-0.5,0.3-1.2,0.3-2.2,0.3c-0.1-0.5-0.3-1.3-0.6-1.8c0.6,0,1.2,0,1.3,0c0.2,0,0.3-0.1,0.3-0.2v-5h-2.6v-4.8h6.8v4.8H94.4z
		 M91.7,110.5h3V109h-3V110.5z M96.1,112.4c0.6,1,1.1,2.3,1.3,3.2l-1.6,0.7c-0.2-0.9-0.7-2.3-1.2-3.3L96.1,112.4z M103.7,117.3
		c0.1,0,0.3,0,0.3-0.1c0.1,0,0.1-0.2,0.2-0.5c0.1-0.3,0.1-1,0.1-2c0.4,0.4,1.1,0.7,1.6,0.9c0,0.8-0.1,1.8-0.2,2.2
		c-0.1,0.4-0.4,0.7-0.7,0.8c-0.3,0.2-0.7,0.2-1.1,0.2h-1.1c-0.4,0-0.9-0.1-1.2-0.4c-0.3-0.3-0.5-0.7-0.5-1.9v-4.1
		c-0.6,2.6-1.6,5.1-3.5,6.9c-0.3-0.5-0.9-1-1.5-1.3c2.4-2.2,3.3-5.5,3.6-9.1h-2.1V107h2.3c0.1-1.5,0.1-3.1,0.1-4.5h2
		c0,1.5,0,3-0.1,4.5h3.8v1.9h-3.9c0,0.3-0.1,0.6-0.1,0.9h1.4v6.8c0,0.3,0,0.5,0.1,0.6c0.1,0.1,0.1,0.1,0.3,0.1H103.7z M103.8,106.8
		c-0.3-0.8-1.1-2-1.8-2.9l1.4-0.8c0.7,0.8,1.5,2,1.9,2.8L103.8,106.8z"
            />
            <path
              fill="#F17752"
              d="M106.9,118.5c0.7-0.9,1.7-2.4,2.2-3.7l2.1,0.6c-0.6,1.4-1.5,3-2.2,4L106.9,118.5z M109.7,114.6h-2v-11.5h5.7
		v4.4c2-0.6,2.8-1.4,3.1-2.6H114v-1.9h9.3c0,0,0,0.5,0,0.7c-0.1,2.4-0.3,3.6-0.7,4c-0.3,0.4-0.8,0.5-1.2,0.6c-0.5,0.1-1.3,0.1-2.1,0
		c0-0.5-0.2-1.2-0.5-1.7c0.7,0.1,1.3,0.1,1.6,0.1c0.3,0,0.4,0,0.5-0.2c0.2-0.2,0.3-0.6,0.4-1.7h-2.5c-0.4,1.9-1.2,3.2-3.7,4.1h7.7
		v5.4h-8.2v-5.2l0,0c-0.2-0.5-0.6-1.1-1-1.5v6.1h-3.7V114.6z M109.7,105v2.3h1.7V105H109.7z M111.5,111.8v-2.6h-1.7v2.6H111.5z
		 M114.1,115.2c0.2,1.2,0.5,2.7,0.5,3.7l-2.1,0.3c0-0.9-0.1-2.5-0.3-3.8L114.1,115.2z M117.9,115.1c0.5,1.1,0.9,2.7,1.1,3.7
		l-2.1,0.4c-0.1-0.9-0.5-2.5-0.9-3.7L117.9,115.1z M116.5,112.7h4v-1.9h-4V112.7z M121.5,114.6c0.7,1.2,1.7,2.7,2.1,3.8l-2.1,0.9
		c-0.4-1-1.2-2.7-2-3.9L121.5,114.6z"
            />
            <path
              fill="#F17752"
              d="M140.8,111c-0.8,1.5-1.8,2.8-3,3.9c0.5,1.4,1,2.2,1.6,2.2c0.4,0,0.6-0.9,0.7-3c0.5,0.5,1.2,1,1.8,1.2
		c-0.3,3.2-1,3.9-2.6,3.9c-1.3,0-2.3-1.1-3.1-2.8c-1,0.9-2.2,1.6-3.3,2.2c-0.3-0.5-0.9-1.2-1.4-1.7c1.4-0.6,2.8-1.5,4-2.5
		c-0.4-1.4-0.7-3.1-0.9-4.8h-3.7v2.1c0.9-0.2,1.9-0.3,2.8-0.5l0.2,1.9l-2.9,0.6v3.1c0,1.2-0.3,1.7-1,2.1c-0.7,0.3-1.8,0.4-3.2,0.4
		c-0.1-0.6-0.5-1.6-0.8-2.2c1,0.1,2.1,0,2.4,0c0.3,0,0.4-0.1,0.4-0.4v-2.6c-1.2,0.2-2.3,0.5-3.2,0.6l-0.5-2.2c1-0.2,2.3-0.4,3.7-0.6
		v-2.4h-3.4v-2h3.4v-2.1c-1,0.2-2,0.3-2.9,0.4c-0.1-0.5-0.4-1.3-0.6-1.8c2.5-0.3,5.3-0.9,7.1-1.5l1.4,1.8c-0.9,0.3-1.9,0.5-2.9,0.7
		v2.4h3.5c-0.1-1.6-0.2-3.3-0.2-4.9h2.3c0,1.7,0,3.3,0.2,4.9h4.9v2h-4.7c0.1,1.1,0.3,2.1,0.5,3c0.6-0.8,1.2-1.6,1.7-2.4L140.8,111z
		 M139.5,107c-0.5-0.8-1.6-2.1-2.6-3l1.6-1.1c1,0.8,2.1,2,2.7,2.9L139.5,107z"
            />
            <path
              fill="#F17752"
              d="M148.6,112.1c-0.6,0.2-1.1,0.3-1.7,0.5v4.4c0,1-0.2,1.5-0.7,1.9c-0.5,0.3-1.3,0.4-2.5,0.4c0-0.5-0.3-1.4-0.5-2
		c0.6,0,1.3,0,1.5,0c0.2,0,0.3-0.1,0.3-0.3v-3.8l-1.7,0.5l-0.5-2.1c0.6-0.1,1.4-0.3,2.2-0.6v-3.2H143v-2h1.9v-3.4h2v3.4h1.6v2h-1.6
		v2.6l1.4-0.4L148.6,112.1z M157.9,113.4c-0.4,1-0.9,1.9-1.5,2.7c1.2,0.5,2.3,1.1,3.1,1.6l-1.4,1.6c-0.8-0.5-2-1.2-3.3-1.8
		c-1.4,0.8-3.2,1.4-5.5,1.8c-0.1-0.6-0.6-1.4-0.9-1.8c1.7-0.2,3-0.5,4.1-1c-1-0.4-2.1-0.8-3-1.1c0.4-0.5,0.9-1.2,1.3-1.9h-2.1v-1.8
		h3.2c0.3-0.6,0.5-1.1,0.8-1.6h-3.7v-1.8h2.6c-0.2-0.5-0.6-1.3-0.9-1.9l1.4-0.5h-2.6v-1.8h3.9c-0.2-0.5-0.4-0.9-0.6-1.3l2.4-0.4
		c0.3,0.5,0.6,1.1,0.9,1.7h3.3v1.8h-2.9l1.6,0.5c-0.4,0.6-0.7,1.3-1,1.8h2.6v1.8H153l1.6,0.3c-0.2,0.4-0.4,0.8-0.6,1.3h2.2
		c0.1-0.3,0.2-0.7,0.2-1.1l2,0.3c0,0.3-0.1,0.5-0.1,0.8h1.4v1.8H157.9z M152.4,105.9c0.4,0.6,0.8,1.3,1,1.9l-1.3,0.5h2.7
		c0.3-0.6,0.8-1.6,1-2.3H152.4z M153,113.4c-0.2,0.4-0.5,0.7-0.7,1.1c0.7,0.2,1.4,0.5,2.1,0.8c0.5-0.5,0.9-1.1,1.3-1.8H153z"
            />
            <path
              fill="#F17752"
              d="M170.1,105.9v2.8l0.4-0.4c1.9,1,4.8,2.5,6.1,3.6l-1.6,2c-1-0.9-3.1-2.2-4.9-3.3v8.6h-2.3v-13.3h-6.5v-2.2h16
		v2.2H170.1z"
            />
            <path
              fill="#F17752"
              d="M193.9,113.1c-0.5-0.6-1.4-1.4-2.3-2.1c-0.4,0.6-0.8,1.1-1.2,1.5c-0.3-0.3-0.9-0.6-1.4-0.9
		c1.6,2.1,4.2,4,6.9,5c-0.5,0.5-1.2,1.4-1.6,2c-2.2-1-4.2-2.6-5.8-4.6v5.2h-2.3v-5.1c-1.6,1.9-3.6,3.5-5.8,4.4
		c-0.3-0.5-1-1.4-1.5-1.8c2.9-1.1,5.7-3.4,7.3-5.8v-4.2h-6.6v-2.1h6.6v-2.2h2.3v2.2h6.8v2.1h-6.8v4c0.1,0.1,0.2,0.3,0.3,0.4
		c1.2-1,1.9-2.6,2.3-4.3l2.1,0.4c-0.2,0.7-0.4,1.3-0.6,1.9c1,0.8,2.3,1.7,2.9,2.4L193.9,113.1z M184.6,107.3
		c-0.2,0.7-0.4,1.3-0.6,1.9c0.6,0.6,1.3,1.2,1.7,1.6l-1.4,1.5c-0.3-0.3-0.7-0.8-1.2-1.3c-0.6,1-1.3,1.8-2.1,2.5
		c-0.3-0.4-1.2-1.1-1.7-1.4c1.6-1.1,2.7-3,3.2-5.2L184.6,107.3z"
            />
            <path
              fill="#F17752"
              d="M211.7,117.1c0.3,0,0.4-0.2,0.4-1.9c0.4,0.3,1.3,0.7,1.8,0.8c-0.2,2.4-0.7,3.1-2,3.1h-1.2c-1.6,0-2-0.6-2-2.5
		V113H208c-0.3,2.8-0.9,5.1-3.9,6.4c-0.2-0.4-0.7-1.1-1.1-1.5v0.4h-3.5v0.8h-1.8v-6.2h5.3v4.8c2.2-1,2.6-2.6,2.8-4.7h-1.2v-4.9
		c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3-0.4-1.1-1.2-1.5-1.5l0.1-0.1H197v-1.7h2.7c-0.2-0.7-0.5-1.6-0.9-2.3l1.8-0.6c0.4,0.7,0.8,1.7,1,2.3
		l-1.4,0.5h3.2v1c1-1,2-2.4,2.6-3.7l2,0.6c-0.6,1.4-1.5,2.8-2.5,4h6.2c-0.8-1.2-1.9-2.6-3-3.7l1.5-1c1.4,1.4,3.1,3.4,3.8,4.8
		l-1.6,1.2c-0.1-0.2-0.2-0.4-0.4-0.6v5.1h-1.1v3.6c0,0.5,0,0.6,0.3,0.6H211.7z M202.8,109.6h-5.1v-1.6h5.1V109.6z M197.7,110.4h5.1
		v1.6h-5.1V110.4z M201.3,114.5h-1.7v2h1.7V114.5z M206.7,111.1h3.2v-2h-3.2V111.1z"
            />
            <path
              fill="#F17752"
              d="M231.4,105.2c0,0,0,0.7,0,1c-0.2,8-0.4,10.9-1.2,11.9c-0.5,0.7-1,0.9-1.7,1c-0.7,0.1-1.8,0.1-2.8,0
		c0-0.6-0.3-1.5-0.7-2.1c1.2,0.1,2.2,0.1,2.7,0.1c0.4,0,0.6-0.1,0.8-0.3c0.5-0.6,0.8-3.3,1-9.6h-3.9c-0.5,1.1-1,2.1-1.6,2.8
		c-0.3-0.3-0.9-0.7-1.4-1v8.4h-4.8v1.3h-1.9v-13.4h2c0.2-0.9,0.5-2.1,0.5-2.9l2.3,0.3c-0.3,0.9-0.6,1.8-0.9,2.6h2.8v2.9
		c1-1.5,1.9-3.7,2.4-5.8l2,0.5c-0.2,0.8-0.4,1.5-0.7,2.3H231.4z M220.6,107.2h-2.9v2.9h2.9V107.2z M220.6,115.5V112h-2.9v3.5H220.6z
		 M226.6,114.6c-0.5-1.1-1.6-2.8-2.5-4.2l1.7-1c0.9,1.2,2.1,3,2.6,4L226.6,114.6z"
            />
            <path
              fill="#F17752"
              d="M241.1,111.8c-1,1.6-2.2,3.1-3.3,4.4l7.3-0.4c-0.6-0.9-1.3-1.8-1.9-2.6l2-0.9c1.6,1.8,3.2,4.2,4,5.8l-2.1,1.1
		c-0.2-0.5-0.5-1-0.8-1.5c-9.1,0.7-10.3,0.8-11.2,1.1c-0.1-0.4-0.5-1.5-0.7-2.1c0.5-0.1,0.8-0.5,1.4-1.1c0.4-0.5,1.7-2.1,2.7-3.8
		h-5.1v-2.2h7v-2.6h-5.6v-2.2h5.6v-2.5h2.3v2.5h5.8v2.2h-5.8v2.6h7.1v2.2H241.1z"
            />
            <path
              fill="#F17752"
              d="M256.3,103.1c-0.4,1.2-0.9,2.4-1.4,3.6v12.5h-2v-9c-0.4,0.5-0.7,1-1.1,1.5c-0.2-0.5-0.7-1.8-1-2.3
		c1.5-1.7,2.8-4.3,3.6-6.9L256.3,103.1z M267.1,107.6c-0.3,2.8-0.7,5.2-1.6,7.1c0.6,1.2,1.5,2.1,2.6,2.8c-0.4,0.4-1,1.2-1.3,1.7
		c-1-0.7-1.7-1.6-2.3-2.6c-0.7,1-1.6,1.9-2.7,2.6c-0.2-0.4-0.9-1.1-1.3-1.4c0.2-0.1,0.5-0.3,0.7-0.5h-3.4v1.3h-1.8v-8h1.8v-2.9h-2.1
		v-1.9h2.1v-3h2v3h1.9v1.9h-1.9v2.9h1.4c-0.2-0.2-0.3-0.4-0.4-0.6c1.2-1.8,1.9-4.6,2.3-7.5l1.9,0.3c-0.2,1-0.3,2-0.6,3h3.7v1.8
		H267.1z M259.5,112.4h-1.9v3.1h1.9V112.4z M261.4,117.1c0.8-0.7,1.5-1.5,2.1-2.4c-0.5-1.2-0.8-2.5-1.1-3.8c-0.2,0.4-0.4,0.7-0.6,1
		c-0.1-0.2-0.2-0.4-0.4-0.6V117.1z M263.8,107.6c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,1.4,0.4,2.8,0.8,4.2c0.4-1.4,0.7-3,0.8-4.7H263.8z"
            />
            <path
              fill="#F17752"
              d="M272.4,113c-0.4,1.8-1.1,3.6-1.8,4.8c-0.3-0.3-1.1-0.8-1.5-1c0.7-1,1.2-2.6,1.5-4.2L272.4,113z M277.6,106.4
		h-8.2v-1.9h3.4c-0.2-0.5-0.4-1.2-0.6-1.7l2-0.4c0.3,0.6,0.6,1.4,0.8,2.1h2.7V106.4z M274.7,112.1v5.1c0,0.9-0.1,1.3-0.7,1.6
		c-0.5,0.3-1.2,0.3-2.2,0.3c-0.1-0.5-0.3-1.3-0.6-1.8c0.6,0,1.2,0,1.3,0c0.2,0,0.3-0.1,0.3-0.2v-5h-2.6v-4.8h6.8v4.8H274.7z
		 M272,110.5h3V109h-3V110.5z M276.4,112.4c0.6,1,1.1,2.3,1.3,3.2l-1.6,0.7c-0.2-0.9-0.7-2.3-1.2-3.3L276.4,112.4z M284,117.3
		c0.1,0,0.3,0,0.3-0.1c0.1,0,0.1-0.2,0.2-0.5c0.1-0.3,0.1-1,0.1-2c0.4,0.4,1.1,0.7,1.6,0.9c0,0.8-0.1,1.8-0.2,2.2
		c-0.1,0.4-0.4,0.7-0.7,0.8c-0.3,0.2-0.7,0.2-1.1,0.2h-1.1c-0.4,0-0.9-0.1-1.2-0.4c-0.3-0.3-0.5-0.7-0.5-1.9v-4.1
		c-0.6,2.6-1.6,5.1-3.5,6.9c-0.3-0.5-0.9-1-1.5-1.3c2.4-2.2,3.3-5.5,3.6-9.1h-2.1V107h2.3c0.1-1.5,0.1-3.1,0.1-4.5h2
		c0,1.5,0,3-0.1,4.5h3.8v1.9h-3.9c0,0.3-0.1,0.6-0.1,0.9h1.4v6.8c0,0.3,0,0.5,0.1,0.6c0.1,0.1,0.1,0.1,0.3,0.1H284z M284.1,106.8
		c-0.3-0.8-1.1-2-1.8-2.9l1.4-0.8c0.7,0.8,1.5,2,1.9,2.8L284.1,106.8z"
            />
            <path
              fill="#F17752"
              d="M68.5,130.7c-0.5,0.9-1.2,1.9-1.9,2.8v9.4h-2.1v-7c-0.5,0.5-1,0.9-1.5,1.3c-0.3-0.4-1-1.4-1.5-1.9
		c1.8-1.3,3.8-3.3,5-5.4L68.5,130.7z M67.8,126.9c-1.3,1.7-3.2,3.5-5,4.7c-0.3-0.5-0.8-1.3-1.2-1.7c1.5-1,3.2-2.6,4.1-3.8
		L67.8,126.9z M78.4,134.1H76v6.3c0,1.2-0.2,1.7-1,2.1c-0.8,0.3-1.9,0.4-3.5,0.4c-0.1-0.6-0.4-1.6-0.6-2.2c1,0.1,2.2,0.1,2.5,0
		c0.3,0,0.5-0.1,0.5-0.3v-6.3h-5.3v-2h10V134.1z M78,129.1h-8.8v-2H78V129.1z"
            />
            <path
              fill="#F17752"
              d="M96.4,128.5c-1.7,1.8-3.9,3.7-6.2,5v7c0,1.2-0.3,1.8-1.2,2.1c-0.9,0.3-2.2,0.4-3.9,0.4
		c-0.1-0.6-0.5-1.6-0.9-2.2c1.3,0.1,2.8,0,3.2,0c0.4,0,0.5-0.1,0.5-0.4v-8c1.4-0.7,3-1.9,4.1-3H81.7v-2.1h12.5l0.5-0.1L96.4,128.5z"
            />
            <path
              fill="#F17752"
              d="M101,137.3c1.6,0,2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9S99.4,137.3,101,137.3z M101,141.8
		c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6c-0.9,0-1.6,0.7-1.6,1.6C99.4,141.1,100.1,141.8,101,141.8z"
            />
            <path
              fill="#F17752"
              d="M118.8,130.4c-0.2,0.4-0.3,0.8-0.5,1.1h5.4v11.3h-2.2v-0.8h-8.2v0.8h-2.1v-11.3h4.8c0.1-0.4,0.2-0.8,0.3-1.1
		h-6.8v-2h4.1c-0.4-0.6-0.9-1.2-1.3-1.7l1.9-0.9c0.7,0.6,1.4,1.5,1.7,2.1l-0.8,0.4h4.1c0.5-0.7,1.1-1.7,1.4-2.4l2.5,0.5
		c-0.5,0.7-1,1.4-1.4,1.9h4v2H118.8z M121.5,133.4h-8.2v1.1h8.2V133.4z M121.5,136.1h-8.2v1.2h8.2V136.1z M121.5,140.2V139h-8.2v1.2
		H121.5z"
            />
            <path
              fill="#F17752"
              d="M141.8,140.6c0.5,0,0.6-0.3,0.7-2.5c0.4,0.4,1.4,0.7,1.9,0.9c-0.2,2.8-0.8,3.6-2.5,3.6h-2.1
		c-2,0-2.5-0.7-2.5-2.7v-4.4h-2.6c-0.4,3.2-1.3,5.9-5.5,7.5c-0.3-0.6-0.8-1.4-1.3-1.9c3.6-1.2,4.3-3.2,4.5-5.6h-4.2v-2.1h6.9v-2.9
		h-3.1c-0.4,0.9-0.9,1.8-1.4,2.4c-0.5-0.3-1.4-0.7-1.9-0.9c1.2-1.5,2-3.9,2.4-5.7l2.2,0.4c-0.2,0.6-0.3,1.1-0.5,1.7h2.3v-2.4h2.2
		v2.4h5.5v2.1h-5.5v2.9h6.9v2.1h-4.7v4.4c0,0.6,0.1,0.7,0.6,0.7H141.8z"
            />
            <path
              fill="#F17752"
              d="M147.7,142.8c1.4-0.5,2.2-1.2,2.3-2.2c-0.1,0-0.1,0-0.2,0c-0.9,0-1.7-0.6-1.7-1.6c0-1,0.8-1.6,1.8-1.6
		c1.3,0,1.9,1,1.9,2.5c0,2-1.3,3.7-3.5,4.4L147.7,142.8z"
            />
            <path
              fill="#F17752"
              d="M162.2,126.8c-0.5,1.2-1,2.5-1.7,3.7v12.4h-2.1v-9.2c-0.4,0.5-0.8,1-1.2,1.5c-0.2-0.5-0.8-1.7-1.2-2.2
		c1.6-1.6,3.2-4.2,4.1-6.7L162.2,126.8z M168.6,131.3v9.2c0,1-0.2,1.6-0.8,2c-0.6,0.3-1.5,0.4-2.6,0.4c-0.1-0.6-0.4-1.6-0.7-2.2
		c0.8,0,1.5,0,1.8,0c0.2,0,0.3-0.1,0.3-0.3v-9.2h-2.1c-0.5,1-1.1,2-1.7,2.8c-0.4-0.4-1.2-1.1-1.7-1.4c1.4-1.5,2.4-4,3.1-6.5l2.1,0.5
		c-0.2,0.9-0.5,1.8-0.8,2.7h6.2l0.3-0.1l1.5,0.3c-0.2,1.5-0.5,3.1-0.8,4.2l-1.8-0.3c0.1-0.6,0.2-1.3,0.3-2.1H168.6z M165.6,134.5
		c-0.5,2.3-1.4,4.6-2.4,6c-0.4-0.3-1.3-0.9-1.8-1.2c1-1.3,1.8-3.3,2.2-5.3L165.6,134.5z M171.1,133.9c0.9,1.9,1.7,4.2,2,5.9
		l-2.1,0.7c-0.2-1.6-1-4.1-1.8-5.9L171.1,133.9z"
            />
            <path
              fill="#F17752"
              d="M182.1,136.5v4.6c0,0.8-0.1,1.2-0.6,1.5c-0.5,0.3-1.1,0.3-2,0.3c-0.1-0.5-0.3-1.2-0.5-1.6c0.5,0,1,0,1.2,0
		c0.2,0,0.2-0.1,0.2-0.2v-4.5h-1.9V130h1.6c0.1-0.5,0.1-0.9,0.2-1.4h-2.5v5.1c0,2.7-0.2,6.6-1.3,8.9c-0.3-0.3-1.1-0.9-1.5-1.1
		c0.9-2.2,1-5.4,1-7.8v-7h7.9v1.8h-1.6c-0.1,0.5-0.3,1-0.4,1.4h2.1v6.5H182.1z M180.1,137.6c-0.3,1.4-0.7,2.8-1.2,3.8
		c-0.3-0.3-1-0.6-1.4-0.8c0.5-0.8,0.9-2.1,1.1-3.3L180.1,137.6z M182.3,131.5h-2.2v1.1h2.2V131.5z M180.1,135h2.2v-1.1h-2.2V135z
		 M183.2,140.6c-0.2-0.7-0.6-2-1-2.9l1.4-0.5c0.4,0.9,0.9,2.1,1,2.8L183.2,140.6z M187.8,140.5c-0.8,0.9-2.2,1.9-3.3,2.4
		c-0.3-0.4-0.9-0.9-1.3-1.3c1.1-0.5,2.3-1.4,3-2.2L187.8,140.5z M186.8,129.8c0.1-0.4,0.1-0.8,0.2-1.3h-2.8v-1.8h7.6v1.8h-2.8
		c-0.1,0.4-0.3,0.9-0.4,1.3h2.8v9.5h-6.8v-9.5H186.8z M189.6,131.4h-3.1v1.2h3.1V131.4z M189.6,134h-3.1v1.2h3.1V134z M189.6,136.6
		h-3.1v1.2h3.1V136.6z M189.8,139.5c0.8,0.7,1.9,1.7,2.4,2.3l-1.6,1.1c-0.5-0.7-1.5-1.7-2.4-2.4L189.8,139.5z"
            />
            <path
              fill="#F17752"
              d="M194.2,141.4c0.9-0.8,1.7-2,2.2-3.1l1.8,0.8c-0.5,1.1-1.3,2.4-2.2,3.3L194.2,141.4z M210.2,131.6h-15.6V130
		h3.8c-0.1-0.3-0.2-0.7-0.4-1l1.4-0.3h-3.9v-1.7h5.8c-0.1-0.3-0.2-0.6-0.3-0.8l2.1-0.4c0.2,0.4,0.4,0.8,0.5,1.2h5.6v1.7h-3.7
		l1.4,0.3c-0.2,0.4-0.4,0.7-0.6,1h3.8V131.6z M208.3,137.8h-5.5c0.7,0.4,1.4,0.8,1.9,1.2l-1.3,1.3c-0.6-0.6-1.8-1.3-2.8-1.8l0.7-0.7
		h-4.6v-5.5h11.6V137.8z M204.1,141c0.7,0,0.8-0.2,0.9-1.5c0.4,0.3,1.3,0.6,1.8,0.7c-0.2,2-0.8,2.5-2.5,2.5h-2.9
		c-2.3,0-2.8-0.5-2.8-2.2v-1.9h2.1v1.9c0,0.5,0.1,0.5,1,0.5H204.1z M206.2,133.6h-7.5v0.8h7.5V133.6z M206.2,135.7h-7.5v0.8h7.5
		V135.7z M200.1,128.7c0.2,0.4,0.4,0.9,0.5,1.3h3.7c0.2-0.4,0.4-0.9,0.5-1.3H200.1z M208.2,138.2c0.9,1,1.8,2.3,2.2,3.2l-1.9,0.8
		c-0.3-0.9-1.2-2.3-2.1-3.3L208.2,138.2z"
            />
            <path
              fill="#F17752"
              d="M220,140.5c-2.4,0.7-5,1.3-6.9,1.9l-0.5-2l0.8-0.2V134h1.7v5.7l0.9-0.2v-6.9h-2.6v-5.9h6.4v5.9h-2v1.9h1.9v1.9
		h-1.9v2.6c0.6-0.2,1.2-0.3,1.8-0.5L220,140.5z M215.3,130.9h2.6v-2.3h-2.6V130.9z M229.5,136.7c-0.8,0.6-1.7,1.3-2.5,1.9
		c0.7,1,1.6,1.8,2.7,2.4c-0.4,0.4-1,1.3-1.4,1.9c-2.5-1.5-3.8-4.3-4.6-7.8h-1.2v5l2.6-0.6c0,0.6,0,1.5,0.1,1.9
		c-3.5,0.9-4.2,1.2-4.6,1.4c-0.1-0.5-0.6-1.3-0.9-1.7c0.4-0.2,0.8-0.7,0.8-1.5v-12.9h8.2v8.3h-3.2c0.2,0.7,0.4,1.4,0.7,2
		c0.7-0.6,1.5-1.3,2.1-1.8L229.5,136.7z M222.5,128.6v1.4h4.1v-1.4H222.5z M222.5,133.2h4.1v-1.5h-4.1V133.2z"
            />
            <path
              fill="#F17752"
              d="M247.5,134.6c-0.8,1.5-1.8,2.8-3,3.9c0.5,1.4,1,2.2,1.6,2.2c0.4,0,0.6-0.9,0.7-3c0.5,0.5,1.2,1,1.8,1.2
		c-0.3,3.2-1,3.9-2.6,3.9c-1.3,0-2.3-1.1-3.1-2.8c-1,0.9-2.2,1.6-3.3,2.2c-0.3-0.5-0.9-1.2-1.4-1.7c1.4-0.6,2.8-1.5,4-2.5
		c-0.4-1.4-0.7-3.1-0.9-4.8h-3.7v2.1c0.9-0.2,1.9-0.3,2.8-0.5l0.2,1.9l-2.9,0.6v3.1c0,1.2-0.3,1.7-1,2.1c-0.7,0.3-1.8,0.4-3.2,0.4
		c-0.1-0.6-0.5-1.6-0.8-2.2c1,0.1,2.1,0,2.4,0c0.3,0,0.4-0.1,0.4-0.4v-2.6c-1.2,0.2-2.3,0.5-3.2,0.6l-0.5-2.2c1-0.2,2.3-0.4,3.7-0.6
		v-2.4h-3.4v-2h3.4v-2.1c-1,0.2-2,0.3-2.9,0.4c-0.1-0.5-0.4-1.3-0.6-1.8c2.5-0.3,5.3-0.9,7.1-1.5l1.4,1.8c-0.9,0.3-1.9,0.5-2.9,0.7
		v2.4h3.5c-0.1-1.6-0.2-3.3-0.2-4.9h2.3c0,1.7,0,3.3,0.2,4.9h4.9v2h-4.7c0.1,1.1,0.3,2.1,0.5,3c0.6-0.8,1.2-1.6,1.7-2.4L247.5,134.6
		z M246.2,130.6c-0.5-0.8-1.6-2.1-2.6-3l1.6-1.1c1,0.8,2.1,2,2.7,2.9L246.2,130.6z"
            />
            <path
              fill="#F17752"
              d="M265.1,140.7c0.3,0,0.4-0.2,0.4-1.9c0.4,0.3,1.3,0.7,1.8,0.8c-0.2,2.4-0.7,3.1-2,3.1h-1.2c-1.6,0-2-0.6-2-2.5
		v-3.6h-0.8c-0.3,2.8-0.9,5.1-3.9,6.4c-0.2-0.4-0.7-1.1-1.1-1.5v0.4h-3.5v0.8h-1.8v-6.2h5.3v4.8c2.2-1,2.6-2.6,2.8-4.7H258v-4.9
		c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3-0.4-1.1-1.2-1.5-1.5l0.1-0.1h-5.6V129h2.7c-0.2-0.7-0.5-1.6-0.9-2.3l1.8-0.6c0.4,0.7,0.8,1.7,1,2.3
		l-1.4,0.5h3.2v1c1-1,2-2.4,2.6-3.7l2,0.6c-0.6,1.4-1.5,2.8-2.5,4h6.2c-0.8-1.2-1.9-2.6-3-3.7l1.5-1c1.4,1.4,3.1,3.4,3.8,4.8
		l-1.6,1.2c-0.1-0.2-0.2-0.4-0.4-0.6v5.1h-1.1v3.6c0,0.5,0,0.6,0.3,0.6H265.1z M256.2,133.2h-5.1v-1.6h5.1V133.2z M251.1,134h5.1
		v1.6h-5.1V134z M254.6,138.1h-1.7v2h1.7V138.1z M260.1,134.7h3.2v-2h-3.2V134.7z"
            />
            <path
              fill="#F17752"
              d="M283.9,140.7c0.3,0,0.4-0.2,0.4-1.9c0.4,0.3,1.3,0.7,1.8,0.8c-0.2,2.4-0.7,3.1-2,3.1h-1.2c-1.6,0-2-0.6-2-2.5
		v-3.6h-0.8c-0.3,2.8-0.9,5.1-3.9,6.4c-0.2-0.4-0.7-1.1-1.1-1.5v0.4h-3.5v0.8h-1.8v-6.2h5.3v4.8c2.2-1,2.6-2.6,2.8-4.7h-1.2v-4.9
		c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3-0.4-1.1-1.2-1.5-1.5l0.1-0.1h-5.6V129h2.7c-0.2-0.7-0.5-1.6-0.9-2.3l1.8-0.6c0.4,0.7,0.8,1.7,1,2.3
		l-1.4,0.5h3.2v1c1-1,2-2.4,2.6-3.7l2,0.6c-0.6,1.4-1.5,2.8-2.5,4h6.2c-0.8-1.2-1.9-2.6-3-3.7l1.5-1c1.4,1.4,3.1,3.4,3.8,4.8
		l-1.6,1.2c-0.1-0.2-0.2-0.4-0.4-0.6v5.1H283v3.6c0,0.5,0,0.6,0.3,0.6H283.9z M274.9,133.2h-5.1v-1.6h5.1V133.2z M269.9,134h5.1v1.6
		h-5.1V134z M273.4,138.1h-1.7v2h1.7V138.1z M278.8,134.7h3.2v-2h-3.2V134.7z"
            />
            <path
              fill="#F17752"
              d="M68.5,156.8c-0.1,0.3-0.3,0.5-0.4,0.7h8.4v8.9h-2.2v-0.6h-6.5v0.6h-2.1v-5.9c-0.8,0.8-1.7,1.5-2.8,2.2
		c-0.3-0.5-0.9-1.3-1.4-1.7c1.9-1,3.3-2.5,4.4-4.2h-3.8v-1.7h4.7c0.1-0.3,0.2-0.5,0.3-0.8h-3.8v-1.6h4.4c0.1-0.3,0.1-0.5,0.2-0.8
		c-1.5,0.1-3,0.1-4.4,0.1c0-0.5-0.2-1.2-0.4-1.6c4.4,0,9.6-0.2,12.6-0.7l1.3,1.5c-1.9,0.3-4.3,0.5-6.7,0.6c-0.1,0.3-0.2,0.6-0.3,0.9
		h7.1v1.6h-7.6c-0.1,0.3-0.2,0.5-0.3,0.8h8.9v1.7H68.5z M74.3,159.2h-6.5v0.8h6.5V159.2z M74.3,161.3h-6.5v0.8h6.5V161.3z
		 M74.3,164.3v-0.8h-6.5v0.8H74.3z"
            />
            <path
              fill="#F17752"
              d="M85.5,150.4c-0.5,1.2-1,2.5-1.7,3.7v12.4h-2.1v-9.2c-0.4,0.5-0.8,1-1.2,1.5c-0.2-0.5-0.8-1.7-1.2-2.2
		c1.6-1.6,3.2-4.2,4.1-6.7L85.5,150.4z M91.9,154.9v9.2c0,1-0.2,1.6-0.8,2c-0.6,0.3-1.5,0.4-2.6,0.4c-0.1-0.6-0.4-1.6-0.7-2.2
		c0.8,0,1.5,0,1.8,0c0.2,0,0.3-0.1,0.3-0.3v-9.2h-2.1c-0.5,1-1.1,2-1.7,2.8c-0.4-0.4-1.2-1.1-1.7-1.4c1.4-1.5,2.4-4,3.1-6.5l2.1,0.5
		c-0.2,0.9-0.5,1.8-0.8,2.7h6.2l0.3-0.1l1.5,0.3c-0.2,1.5-0.5,3.1-0.8,4.2L94,157c0.1-0.6,0.2-1.3,0.3-2.1H91.9z M88.9,158.1
		c-0.5,2.3-1.4,4.6-2.4,6c-0.4-0.3-1.3-0.9-1.8-1.2c1-1.3,1.8-3.3,2.2-5.3L88.9,158.1z M94.4,157.5c0.9,1.9,1.7,4.2,2,5.9l-2.1,0.7
		c-0.2-1.6-1-4.1-1.8-5.9L94.4,157.5z"
            />
            <path
              fill="#F17752"
              d="M114.2,158.8v1.7h-16v-1.7h7v-0.8h-5.3v-1.6h5.3v-0.6c-1.8,0.1-3.6,0.1-5.2,0.1c0-0.3-0.1-0.7-0.2-1.1h-1.1
		v-3.7h6.7c-0.2-0.4-0.4-0.8-0.6-1.1l2.1-0.6c0.3,0.5,0.7,1.2,1,1.7h6v3.7h-1.3l0.2,0.2c-1.6,0.3-3.5,0.5-5.6,0.7v0.7h5.5v1.6h-5.5
		v0.8H114.2z M100.7,161.2h11.2v5.2h-2.2V166h-7v0.5h-2.1V161.2z M100.7,154.5c1.5,0,3-0.1,4.5-0.1v-1.1h2v1
		c1.7-0.1,3.2-0.3,4.3-0.5l0.1,0.1V153h-10.9V154.5z M102.7,162.9v1.4h7v-1.4H102.7z"
            />
            <path
              fill="#F17752"
              d="M115.6,157.9c0.5-1.2,0.8-3.2,0.9-4.7l1.6,0.2c-0.1,1.5-0.4,3.7-0.8,5.1L115.6,157.9z M132.1,152.8v13.5h-2.2
		v-0.7h-5.1v0.8h-2.1v-10.4l-1.6,0.7c-0.1-0.7-0.5-1.8-0.9-2.8v12.5h-2.1v-16.8h2.1v3.5l1.2-0.5c0.5,1.1,1.1,2.5,1.3,3.4v-3.2h3.1
		c0.2-1,0.5-2.2,0.5-3.1l2.5,0.3c-0.3,1-0.6,2-0.9,2.9H132.1z M124.8,154.9v3.3h5.1v-3.3H124.8z M129.9,163.6v-3.4h-5.1v3.4H129.9z"
            />
            <path
              fill="#F17752"
              d="M139.8,150.4c-0.5,1.1-1,2.3-1.6,3.4v12.6h-2.1v-9.3c-0.5,0.6-0.9,1.2-1.4,1.6c-0.2-0.5-0.8-1.7-1.2-2.2
		c1.7-1.7,3.2-4.2,4.1-6.8L139.8,150.4z M150.4,157.7H146v8.8h-2.2v-8.8h-4.6v-2.1h4.6v-5.7h2.2v5.7h4.4V157.7z"
            />
            <path
              fill="#F17752"
              d="M155.1,152.9v3.1c0,2.9-0.3,7.6-1.6,10.5c-0.4-0.4-1.3-1.1-1.7-1.3c1.2-2.7,1.3-6.5,1.3-9.2v-5h6.8
		c-0.1-0.4-0.2-0.8-0.3-1.1l2.2-0.4c0.2,0.5,0.4,1,0.5,1.5h6.1v1.9H155.1z M157.1,157c0,0.9-0.1,2-0.9,2.8c-0.2-0.3-0.7-0.7-1-0.8
		c0.7-0.5,0.8-1.4,0.8-2v-0.7h1.2V157z M165.3,161.9c0.9,1.1,2.2,2.6,2.9,3.5l-1.6,0.9c-0.2-0.3-0.4-0.6-0.7-0.9
		c-8.5,0.6-9.5,0.6-10.1,0.8c-0.1-0.3-0.3-1.2-0.5-1.7c0.6-0.1,1.2-0.3,2.1-0.8c0.4-0.2,1.2-0.5,2-1c-2.3,0.1-2.7,0.2-3,0.3
		c-0.1-0.3-0.3-1.1-0.5-1.6c0.3,0,0.7-0.2,1.2-0.5c0.5-0.2,1.9-1,3-2c-0.4-0.2-0.5-0.5-0.5-1.2v-1.5h1.1v1.5c0,0.3,0,0.4,0.2,0.4
		c0.1,0,0.4,0,0.6-0.1c0,0.2,0,0.4,0,0.6c0.6-0.5,0.7-1.3,0.7-1.8v-0.7h1.2v0.7c0,0.9-0.1,1.9-1,2.6c-0.2-0.3-0.6-0.6-0.9-0.8l0,0.2
		c-0.1,0.1-0.4,0.1-0.6,0.1h-0.3h0l1.1,0.7c-0.9,0.6-1.9,1.3-2.8,1.8l2.7-0.1c0.8-0.5,1.7-1.1,2.4-1.7l1.6,1.1
		c-1.9,1.3-3.9,2.5-5.8,3.4l5.1-0.3c-0.4-0.4-0.7-0.8-1-1.2L165.3,161.9z M157.6,159.4v-3.8h-2v-1.6h2v-0.8h1.6v0.8h2.2v1.6h-2.2
		v3.8H157.6z M164,159.5v-3.8h-2.2v-1.6h2.2v-0.8h1.6v0.8h2.6v1.6h-2.6v3.8H164z M167.8,158.4c0.2,0,0.5,0,0.7-0.1
		c0,0.3,0,0.6,0.1,0.9c-0.2,0.1-0.5,0.1-0.7,0.1h-0.6c-0.9,0-1.1-0.4-1.1-1.3v-1.8h1.2v1.8c0,0.3,0,0.4,0.2,0.4H167.8z"
            />
            <path
              fill="#F17752"
              d="M172.2,161.5v1.5h-1.9v-11.8h5.2v10.3H172.2z M172.2,153.2v6.3h1.4v-6.3H172.2z M174.7,165.2
		c0.7-1,1.1-2.6,1.3-4.1l1.6,0.5c-0.2,1.5-0.6,3.3-1.3,4.3L174.7,165.2z M186.3,158.7c0,0,0,0.5,0,0.8c-0.2,4.1-0.4,5.7-0.8,6.3
		c-0.3,0.4-0.7,0.6-1.2,0.6c-0.4,0.1-1.1,0.1-1.9,0.1c0-0.6-0.2-1.3-0.5-1.8c0.6,0.1,1.1,0.1,1.4,0.1c0.2,0,0.4,0,0.5-0.2
		c0.2-0.3,0.4-1.3,0.5-4h-7.8v-10.1h9.3v1.9h-3.4v1h2.9v1.7h-2.9v1h2.9v1.7h-2.9v1.1H186.3z M179.3,161.2c0.3,1.2,0.5,2.7,0.4,3.7
		l-1.5,0.2c0.1-1-0.1-2.5-0.3-3.7L179.3,161.2z M178.5,152.2v1h1.9v-1H178.5z M180.5,154.9h-1.9v1h1.9V154.9z M178.5,158.7h1.9v-1.1
		h-1.9V158.7z M181.2,161c0.4,1,0.8,2.3,0.9,3.1l-1.4,0.4c-0.1-0.9-0.4-2.2-0.8-3.2L181.2,161z M182.8,163.6c-0.1-0.7-0.5-1.7-1-2.5
		l1.1-0.4c0.5,0.8,0.9,1.8,1.1,2.4L182.8,163.6z"
            />
            <path
              fill="#F17752"
              d="M195.4,155.1c0-1.1-0.9-1.7-2.3-1.7c-1.1,0-2.1,0.5-2.9,1.4l-1.5-1.4c1.1-1.3,2.7-2.2,4.6-2.2
		c2.6,0,4.5,1.2,4.5,3.6c0,2.6-3.9,3-3.7,5.5H192C191.6,157.5,195.4,156.8,195.4,155.1z M193.2,161.5c1.1,0,1.9,0.7,1.9,1.8
		s-0.8,1.8-1.9,1.8s-1.9-0.7-1.9-1.8S192.1,161.5,193.2,161.5z"
            />
            <path fill="#F17752" d="M205.9,166.6h-6v-1.9h3.8v-9.6h2.1V166.6z" />
          </g>
        </svg>
      </div>
    );
  }
}

export default DialogIText;



// WEBPACK FOOTER //
// ./src/storyA/components/DialogIText.tsx